export default "__VITE_ASSET__2fa9c3fa__"